import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { withLanguageRewrite } from '@/store/handleRequestLanguage';
import { apiGateway } from 'api/apiHost';

const baseQuery = fetchBaseQuery({
  baseUrl: apiGateway.proxyPath,
});

export const literatureHubApi = createApi({
  reducerPath: 'literatureHubAPI',
  baseQuery: withLanguageRewrite(baseQuery),
  endpoints: (build) => ({
    fetchDocuments: build.query({
      query: (body) => ({
        url: '/library/Adviser',
        method: 'POST',
        body: body,
      }),
    }),
    fetchAuthorisedFundLiterature: build.query({
      query: (body) => ({
        url: '/library/authorisedFundLiterature',
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const { useLazyFetchDocumentsQuery, useLazyFetchAuthorisedFundLiteratureQuery } =
  literatureHubApi;
